export const AWS_ENDPOINT = {
  ORIGIN: process.env.REACT_APP_AWS_ENDPOINT + "origin/",
  W350: process.env.REACT_APP_AWS_ENDPOINT + "w_350/",
  W280: process.env.REACT_APP_AWS_ENDPOINT + "w_280/",
};
